$(function () {
  if ($(".js-acf-swiper").length === 0) return;

  const swiper = new Swiper(".js-acf-swiper", {
    loop: true,
    slidesPerView: 1,
    effect: "fade",
    speed: 600,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".productSliderPagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".productSliderNext",
      prevEl: ".productSliderPrev",
    },
  });
});